import React, { useEffect, useState } from "react";
import { View, Text } from "react-native";
import { Dropdown } from "react-native-element-dropdown";

export default function DropDownPicker({
  items = [],
  defaultValue = null,
  onChangeItem,
  disabled = false,
  error = false,
  placeholder = "Select an option",
  bColor = "#fbebf3",
}) {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (item) => {
    setValue(item.value);
    if (onChangeItem) onChangeItem(item);
  };

  return (
    <View style={{ width: "100%", marginBottom: 6 }}>
      <Dropdown
        data={items}
        labelField="label"
        valueField="value"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disable={disabled}
        search={true}
        searchPlaceholder="Search..."
        inputSearchStyle={{
          height: 40,
          fontSize: 14,
          paddingHorizontal: 10,
          borderBottomWidth: 1,
          borderColor: "#ccc",
          outlineWidth: 0,     
        }}

        style={{
          height: 45,
          borderRadius: 5,
          borderWidth: 1,
          borderColor: disabled ? "#d0d0d0" : bColor,
          paddingHorizontal: 10,
          backgroundColor: disabled ? "#f2f2f2" : "rgb(249, 250, 251)",
        }}
        selectedTextStyle={{
          color: "#000",
          fontSize: 14,
        }}
        
        placeholderStyle={{
          color: "#888",
          fontSize: 14,
        }}
        itemTextStyle={{
          color: "#000",
        }}
        containerStyle={{
          borderRadius: 5,
          borderWidth: 1,
          borderColor: "#e0e0e0",
          maxHeight: 250, // increased height for search + items
        }}
      />

      {error && (
        <Text style={{ color: "red", marginTop: 4, alignSelf: "flex-end" }}>
          *Required
        </Text>
      )}
    </View>
  );
}
